module.exports = "<p>\n  not-permitted works!\n</p>\n"